import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const GetEmailDetailsContext = React.createContext({});
export let getEmailDetailsMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMGetEmailDetails = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getEmailDetailsMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(getEmailDetailsMachine);

  return {
    getEmailDetailsMachine,
    getEmailDetailsState: state,
    getEmailDetailsSend: send,
  };
};
